module.exports = __webpack_public_path__ + "img/CM-MC-26-CJDR-Playful.4df58aa4.jpg";